import { Div } from '../base/components/native/div'
import { Img } from '../base/components/native/img'
import { HIDE, SHOW } from '../base/helpers/style'
import emitter from '../base/utils/emitter'
import images from '../configs/images'

export const Cart = () => {

    const base = Div()
    base.el.classList.add('snipcart-summary')
    const icon = Img(images.ICONS.CART, {width: 24})
    const items = Div()
    items.el.classList.add('snipcart-total-items')
    icon.el.classList.add('snipcart-checkout')
    base.append( icon,items)
    emitter.on('route-changed', (r: string) => {(location.href.includes('#')) ? base.style(HIDE) : base.style(SHOW)})

    items.cssClass({
        color: 'white',
        marginLeft: '5px',
    })
    base.cssClass({
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        position: 'absolute',
        top: '0',
        right: '10px',
        padding: '10px',
        zIndex: '1'
    })

    return base
}